export const SET_INVOICE_LIST = "SET_INVOICE_LIST";
export const SET_ACTUAL_INVOICELIST = "SET_ACTUAL_INVOICELIST";
export const SET_TOTAL_NUMBER_OF_RECORDS = "SET_TOTAL_NUMBER_OF_RECORDS";
export const SET_ACTIVE_PAGE = "SET_ACTIVE_PAGE";
export const SET_SHOW_MODAL = "SET_SHOW_MODAL";
export const SET_RECORDS_PERPAGE = "SET_RECORDS_PERPAGE";
export const SET_PAGE_COUNT = "SET_PAGE_COUNT";
export const SET_GOTO = "SET_GOTO";
export const SET_SLICED_DATA = "SET_SLICED_DATA";
export const SET_FILTERED_DATA = "SET_FILTERED_DATA";
export const SET_TABLE_DATA = "SET_TABLE_DATA";
export const SET_ACTION_NAME = "SET_ACTION_NAME";
export const SET_FULL_SEARCH_DATA = "SET_FULL_SEARCH_DATA";
export const SET_DATE_FROM = "SET_DATE_FROM";
export const SET_DATE_TO = "SET_DATE_TO";
export const SET_SORT_STATUS_INVOICE_NO = "SET_SORT_STATUS_INVOICE_NO";
export const SET_SORT_STATUS_INVOICE_DATE = "SET_SORT_STATUS_INVOICE_DATE";
export const SET_SORT_STATUS_CONTRACT = "SET_SORT_STATUS_CONTRACT";
export const SET_SORT_STATUS_LOCATION = "SET_SORT_STATUS_LOCATION";
export const SET_SORT_STATUS_AMOUNT = "SET_SORT_STATUS_AMOUNT";
export const SET_SORT_STATUS_DUE_AMOUNT = "SET_SORT_STATUS_DUE_AMOUNT";
export const SET_SORT_STATUS_PAY_STATUS = "SET_SORT_STATUS_PAY_STATUS";
export const SET_SORT_STATUS_DUE_DATE = "SET_SORT_STATUS_DUE_DATE";
export const SET_SEARCH_OR_REFRESH = "SET_SEARCH_OR_REFRESH";
export const SET_VISIBLE_MAKE_PAYMENT = "SET_VISIBLE_MAKE_PAYMENT";
export const SET_VISIBLE_MANAGE_PAYMENT = "SET_VISIBLE_MANAGE_PAYMENT";
export const SET_VISIBLE_MANAGE_PAPERLESS_BILLING = "SET_VISIBLE_MANAGE_PAPERLESS_BILLING";
export const SET_VISIBLE_RECURRING_PAYMENT = "SET_VISIBLE_RECURRING_PAYMENT";
export const SET_TOKEN = "SET_TOKEN";
export const SET_SESSION_ID = "SET_SESSION_ID";
export const SET_VEPS_URL = "SET_VEPS_URL";
export const RESET = "RESET";
export const LOAD_DATA = "LOAD_DATA";
export const SET_ALERT_MODAL = "SET_ALERT_MODAL";
export const SET_LOADER = "SET_LOADER";
export const SET_IS_ERROR = "SET_IS_ERROR";
export const SET_VIEW_INVOICE_ERROR = "SET_VIEW_INVOICE_ERROR";
export const SET_DOWNLOAD_INVOICE_ERROR = "SET_DOWNLOAD_INVOICE_ERROR";

export function loadData(value, responseData) {
  return {
    type: LOAD_DATA,
    value,
    responseData,
  };
}

export function reset() {
  return {
    type: RESET,
  };
}

export function setInvoiceList(value) {
  return {
    type: SET_INVOICE_LIST,
    value,
  };
}

export function setActualInvoicelist(value) {
  return {
    type: SET_ACTUAL_INVOICELIST,
    value,
  };
}
export function setTotalNumberOfRecords(value) {
  return {
    type: SET_TOTAL_NUMBER_OF_RECORDS,
    value,
  };
}
export function setActivePage(value) {
  return {
    type: SET_ACTIVE_PAGE,
    value,
  };
}
export function setShowModal(value) {
  return {
    type: SET_SHOW_MODAL,
    value,
  };
}
export function setRecordsPerpage(value) {
  return {
    type: SET_RECORDS_PERPAGE,
    value,
  };
}
export function setPageCount(value) {
  return {
    type: SET_PAGE_COUNT,
    value,
  };
}
export function setGoto(value) {
  return {
    type: SET_GOTO,
    value,
  };
}
export function setSlicedData(value) {
  return {
    type: SET_SLICED_DATA,
    value,
  };
}
export function setFilteredData(value) {
  return {
    type: SET_FILTERED_DATA,
    value,
  };
}
export function setTableData(value) {
  return {
    type: SET_TABLE_DATA,
    value,
  };
}
export function setActionName(value) {
  return {
    type: SET_ACTION_NAME,
    value,
  };
}

export function setFullSearchData(value) {
  return {
    type: SET_FULL_SEARCH_DATA,
    value,
  };
}
export function setDateFrom(value) {
  return {
    type: SET_DATE_FROM,
    value,
  };
}
export function setDateTo(value) {
  return {
    type: SET_DATE_TO,
    value,
  };
}
export function setSortStatusInvoiceNo(value) {
  return {
    type: SET_SORT_STATUS_INVOICE_NO,
    value,
  };
}
export function setSortStatusInvoiceDate(value) {
  return {
    type: SET_SORT_STATUS_INVOICE_DATE,
    value,
  };
}
export function setSortStatusContract(value) {
  return {
    type: SET_SORT_STATUS_CONTRACT,
    value,
  };
}
export function setSortStatusLocation(value) {
  return {
    type: SET_SORT_STATUS_LOCATION,
    value,
  };
}
export function setSortStatusAmount(value) {
  return {
    type: SET_SORT_STATUS_AMOUNT,
    value,
  };
}
export function setSortStatusDueAmount(value) {
  return {
    type: SET_SORT_STATUS_DUE_AMOUNT,
    value,
  };
}
export function setSortStatusPayStatus(value) {
  return {
    type: SET_SORT_STATUS_PAY_STATUS,
    value,
  };
}
export function setSortStatusDueDate(value) {
  return {
    type: SET_SORT_STATUS_DUE_DATE,
    value,
  };
}
export function setSearchOrRefresh(value) {
  return {
    type: SET_SEARCH_OR_REFRESH,
    value,
  };
}
export function setVisibleMakePayment(value) {
  return {
    type: SET_VISIBLE_MAKE_PAYMENT,
    value,
  };
}
export function setVisibleManagePayment(value) {
  return {
    type: SET_VISIBLE_MANAGE_PAYMENT,
    value,
  };
}
export function setVisibleManagePaperlessBilling(value) {
  return {
    type: SET_VISIBLE_MANAGE_PAPERLESS_BILLING,
    value,
  };
}
export function setVisibleRecurringPayment(value) {
  return {
    type: SET_VISIBLE_RECURRING_PAYMENT,
    value,
  };
}
export function setToken(value) {
  return {
    type: SET_TOKEN,
    value,
  };
}
export function setSessionId(value) {
  return {
    type: SET_SESSION_ID,
    value,
  };
}
export function setVepsURL(value) {
  return {
    type: SET_VEPS_URL,
    value,
  };
}
export function setAlertModal(value) {
  return {
    type: SET_ALERT_MODAL,
    value,
  };
}
export function setLoader(value) {
  return {
    type: SET_LOADER,
    value,
  };
}
export function setIsError(value) {
  return {
    type: SET_IS_ERROR,
    value,
  };
}
export function setViewInvoiceError(value) {
  return {
    type: SET_VIEW_INVOICE_ERROR,
    value,
  };
}
export function setDownloadInvoiceError(value) {
  return {
    type: SET_DOWNLOAD_INVOICE_ERROR,
    value,
  };
}
